import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="95vh"
          image={`url(${mobileHero}) center / cover no-repeat`}
          column
        >
          <CFView mt="30px" column center w="100%" textCenter>
            <CFImage
              w="95%"
              src={mobileHeroText}
              alt="Yanaki Sushi hero text"
              zIndex={98}
            />
            <CFView pulsate mt="20px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="90vh"
          maxHeight="690px"
          w="100%"
          image={`url(${hero}) 20% 50% / cover no-repeat`}
          zIndex={90}
          column
          justifyCenter
          alignStart
        >
          {/*<Header />*/}
          <CFView column justifyCenter alignStart ml="80px">
            <CFImage
              w="45vw"
              maxWidth="480px"
              src={heroText}
              alt="Yanaki Sushi hero text"
              zIndex={98}
            />
            <CFView pulsate mt="30px" w="28vw" maxWidth="300px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
